import { gql, useMutation } from "@apollo/client";

import type {
  AnnotationInput,
  AddAnnotationMutation,
  AddAnnotationMutationVariables,
} from "../../../API";
import { ADD_ANNOTATION } from "../../../common/operations/mutations";

export const useCreateAnnotation = () => {
  const [saveAnnotation, { data, loading }] = useMutation<
    AddAnnotationMutation,
    AddAnnotationMutationVariables
  >(ADD_ANNOTATION);

  const createAnnotation = async (input: AnnotationInput) => {
    return await saveAnnotation({
      variables: {
        input,
      },
      update(cache, response) {
        cache.modify({
          fields: {
            getAnnotations(existing) {
              const newAnnotationRef = cache.writeFragment({
                data: response.data?.addAnnotation,
                fragment: gql`
                  fragment NewAnnotation on Annotation {
                    annotationType
                    deviceId
                    id
                    name
                    polygon
                    equipmentType
                    serviceId
                    zoneId
                    deviceId
                    tankHeight
                    tankNumber
                    annotateTanks
                    bottomHidden
                  }
                `,
              });

              if (!existing) {
                return response?.data;
              }

              return {
                ...existing,
                items: [...existing.items, newAnnotationRef],
              };
            },
          },
        });
      },
    });
  };

  return { createAnnotation, data, loading };
};
